export enum TransactionsLimits {
  HARD_LIMIT = 17347,
  DAILY_LIMIT = 17372
}
